import type { AdminTab } from "@/stores/react/tabsStore";
import { MoreButton } from "./components/MoreButton";
import { RightMenu } from "./components/RightMenu";
import { SlideToggle } from "./components/SlideToggle";

export interface TabsProps {
    tabs: AdminTab[];
    activePath: string;
    asideHidden: boolean;
    onSelect: (path: string) => void;
    onClose: (path: string) => void;
    onCloseLeft: (path?: string) => void;
    onCloseRight: (path?: string) => void;
    onCloseOthers: (path?: string) => void;
    onCloseAll: () => void;
    onToggleAside: (hidden: boolean) => void;
}

/** 历史标签栏，保留旧 Vue 的页签切换、关闭及侧栏显隐操作。 */
export function Tabs({
    tabs,
    activePath,
    asideHidden,
    onSelect,
    onClose,
    onCloseLeft,
    onCloseRight,
    onCloseOthers,
    onCloseAll,
    onToggleAside
}: TabsProps) {
    return (
        <nav className="admin-layout__tabs tabs-box" aria-label="页面标签">
            <SlideToggle hidden={asideHidden} onChange={onToggleAside} />
            <div className="tabs-menu">
                {tabs.map(tab => (
                    <MoreButton
                        key={tab.path}
                        current={tab.path === activePath}
                        onClose={tab.closable ? () => onClose(tab.path) : undefined}
                        onCloseLeft={() => onCloseLeft(tab.path)}
                        onCloseRight={() => onCloseRight(tab.path)}
                        onCloseOthers={() => onCloseOthers(tab.path)}
                        onCloseAll={onCloseAll}
                    >
                        <span className={tab.path === activePath ? "tab-item is-active" : "tab-item"}>
                            <button type="button" onClick={() => onSelect(tab.path)}>
                                {tab.title}
                            </button>
                            {tab.path === activePath && tab.closable && tabs.length > 1 ? (
                                <button type="button" aria-label={`关闭${tab.title}`} onClick={() => onClose(tab.path)}>
                                    ×
                                </button>
                            ) : null}
                        </span>
                    </MoreButton>
                ))}
            </div>
            <RightMenu onCloseOthers={onCloseOthers} onCloseAll={onCloseAll} />
        </nav>
    );
}

export default Tabs;
